import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { themeDefinition } from '@klarna/designtokens';
import cornerRadii from '@bubble-ui/particle-default-corner-radii';
import spaceTokens from '@bubble-ui/particle-default-space-tokens';
import colorsLight from './colorsLight';
import textStyles from './textStyles';
import colorsDark from './colorsDark';
export var lightTheme = function lightTheme() {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    _theme: themeDefinition({
      identifier: 'lollipop-light',
      name: 'Lollipop (light)',
      options: {
        isDark: false
      }
    })
  }, colorsLight), textStyles), cornerRadii), spaceTokens);
};
export var darkTheme = function darkTheme() {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    _theme: themeDefinition({
      identifier: 'lollipop-dark',
      name: 'Lollipop (dark)',
      options: {
        isDark: false
      }
    })
  }, colorsDark), textStyles), cornerRadii), spaceTokens);
};
export default (function () {
  var isDark = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (isDark) {
    return darkTheme();
  }

  return lightTheme();
});
//# sourceMappingURL=index.js.map